import { memo } from 'react';
import { SCENE_OPTION_MENU_ITEM_COMMON_CLASSNAME } from '../SceneOptionsMenuConstants';
import { useDeleteScene } from '../../useDeleteScene';
import Icon from '@/components/atoms/Icon';

function SceneOptionsMenuDelete({ sceneId, compositeId }: { sceneId: string; compositeId: string }) {
  const { deleteScene } = useDeleteScene();

  const handleRemoveScene = () => {
    deleteScene(sceneId, compositeId);
  };

  return (
    <button className={`${SCENE_OPTION_MENU_ITEM_COMMON_CLASSNAME}`} onClick={handleRemoveScene}>
      <div className="flex items-center gap-2">
        <Icon name="IconTrash" className="size-4" />
        Remove scene
      </div>
      <span />
    </button>
  );
}

export default memo(SceneOptionsMenuDelete);
